module.exports = __webpack_public_path__ + "media/images/athletes/2881-81923fb53ed5b19501456c3a53e79016.png";